import type { ReactNode } from 'react'
import { Reveal } from '../../motion'

/**
 * TableShell — the SINGLE surface wrapper for every dashboard list table.
 *
 * One place for the table panel styling (Kiran 2026-05-21: "change it once, it
 * should reflect everywhere"). Pages keep their own `<table>` / `<thead>` /
 * `<tbody>` (the row shape is page-specific) + the shared `Th`/`Td` cell
 * helpers, but wrap the table in `<TableShell>` instead of a hand-rolled div.
 *
 * Cinematic 2026-06-08: the whole panel reveals on scroll-into-view via the
 * shared `<Reveal>` primitive so every operator + customer table inherits the
 * same calm entrance without per-page edits.
 */
export function TableShell({ children }: { readonly children: ReactNode }): JSX.Element {
  return (
    <Reveal className="table-surface overflow-x-auto rounded-2xl border border-border/40 bg-bg-surface shadow-lg">
      {children}
    </Reveal>
  )
}
